// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums
import { Language } from "@mgs/ci2019-common/src/enums/Language";

import "#/modules/index";
import { User } from "@mgs/ci2019-common/src/models/user/User";
import { IRegion } from "@mgs/ci2019-common/src/interfaces/IRegion";
import { Api } from "#/api";
import { PageState } from "./store/states/PageState";
import { LanguageService } from "@mgs/ci2019-common/src/services/LanguageService";

@Observer
@Component({
  mixins: [template],
})
export class App extends Vue {
  public async mounted() {
    (this.$router as any).start();
    this.checkForIE11();
    await this.reloadLanguage(this.$store.ui.appCurrentLanguage);
  }

  public async reloadLanguage(language: Language) {
    if (
      this.$i18n.locale !== language.toLowerCase() ||
      !this.$store.ui.hasEntryLanguage
    ) {
      const prevHasEntryLanguage = this.$store.ui.hasEntryLanguage;

      if (prevHasEntryLanguage) {
        this.$store.ui.isLoadingAuto = true;
        this.$store.ui.isLoading = true;
      }

      let appLanguages: any = this.$store.ui.appLanguages.get(language);
      let hasAlreadyLanguage: any = appLanguages;

      try {
        if (!appLanguages) {
          appLanguages = await this.$store.ui.getLanguage(language);
        }

        this.$i18n.locale = language;
        this.$i18n.setLocaleMessage(language.toLowerCase(), appLanguages);
        this.$store.ui.setAppCurrentLanguage(language);
        this.$store.ui.hasEntryLanguage = true;
        LanguageService.instance.localizeVeeValidate(language);

        document
          .querySelector("html")!
          .setAttribute("lang", language.toLowerCase());

        if (hasAlreadyLanguage) {
          setTimeout(() => {
            this.$store.ui.isLoadingSuccess = true;
            this.$store.ui.isLoading = false;
            this.$store.ui.isLoadingAuto = true;
          }, 500);
        }
      } catch (err) {
        console.log("changeLanguage", err);
      }
    }
  }

  private checkForIE11() {
    if (window["msCrypto"] !== undefined) {
      this.$store.ui.isIE11 = true;
      document.body.classList.add("ie11");
    }
  }
}
